<template>
<div id="dashboard">
<div v-if="!states.viewAllow && !states.showFail" class="loader overlay">
    <img class="overlay-container" src="@/assets/img/loader.gif" />
  </div>
  <div v-if="states.showFail">
    <p></p>
      <div v-if="states.onServerError" class="text-center">
      <label>Došlo k neočakávanej chybe. Skúste neskôr.</label>
      </div>
      <div v-else>
      <p class="text-center" v-if="tplData.general"><label v-html="tpl('general.errorLoading')"></label></p>
      </div>
  </div>
  <div v-if="states.viewAllow" class="row">
    <div v-show="!states.isPredplatenka && !states.isYoung" class="large-12 medium-12 small-12 columns"><p></p>
      <h2>{{msg}}</h2>
      <hr/>
      <div v-if="states.mainView">
        <div v-if="notAres">
          <div class="chrpln-flex">
            <div>Telefónne číslo:</div>
            <div v-text="formatVMsisdn"></div>
          </div>
          <hr />
        </div>
    <div v-if="notAres" v-html="tpl('change.mainText')"></div>
    <div v-if="!notAres" v-html="tpl('change.mainTextAres') + (formatVMsisdn) + '.'"></div>
    <!-- <div class="disc_flex">
      <div class="check_flex">
        <label class="cechcon">
          <input type="checkbox" id="chck_disc" v-model="checkOk">
          <span class="checkmark"></span>
        </label>
      </div>
      <label for="chck_disc" v-html="tpl('change.disclaimer')"></label>
    </div> -->
    <p class="mt-4"></p>
    <a class="actions action"  v-bind:class="{ check_fail: !checkOk }" v-on:click="callAction('start')" v-text="tpl('change.btnConfirm')"></a>
    </div>
    <div v-if="baseView.addTYPage">
      <p v-html="baseView.TYText" v-bind:class="{ mActive: baseView.TYInfoAlert }"></p><p>&nbsp;</p>
        <a v-on:click="toProfile()" class="actions action" v-if="baseView.TYBtn">PROFIL</a>
    </div>
    <p></p>
    </div>
    <div v-show="states.isPredplatenka" class="large-12 medium-12 small-12 columns">
      <p><br /></p>
      <div v-show="!states.denyOther">
        <p class="text-center"><label>PROGRAM PREDPLATENKA JE UŽ AKTÍVNY.</label></p><p></p><p class="text-center"><router-link to="/balicky">Ponuka nových balíčkov.</router-link></p>
        <div v-html="tpl('change.alreadyActive')"></div>        
      </div>
      <div v-show="states.denyOther">
        <p class="text-center"><label>PRE AKTUÁLNY PROGRAM NIEJE ZMENA POVOLENÁ.</label></p>
      </div>
    </div>

    <div v-show="states.isYoung" class="large-12 medium-12 small-12 columns text-center">
      <div class="swipe-alert">
      Služba SWIPE nie je na tejto stránke podporovaná. Pre pohodlné spravovanie služby SWIPE použite mobilnú aplikáciu SWIPE.
      </div>
    </div>
    <div v-show="states.isSSOFail" class="large-12 medium-12 small-12 columns">
      <img src="@/assets/img/exclamation-fill.svg" class="height-1" /><span v-html="tpl('change.ssoFail')" />
    </div>
    <p></p>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Zmena',
  data () {
    return {
      msg: 'Telekom Predplatenka',
      seen: false,
      tplData: {},
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      states: {
        viewAllow: false, showWait: true, showFail: false, isPredplatenka: false, mainView: true, denyOther: false, onServerError: false, isYoung: false, isSSOFail: false
      },
      baseView: {
        addTYPage: false, TYText: "", TYInfoAlert: false, TYBtn: false
      },
      msisdn: '',
      productdetail: {},
      checkOk: true,
      notAres: true,
      xQuery: this.$route.query
    }
  },
  created: function() {
    var that = this

    if (document.getElementById("msisdnTextSpan") === null) {
      var msisdnTextSpan = document.createElement("span")
      msisdnTextSpan.id = "msisdnTextSpan"
      var msisdnTemp = document.getElementById("jsHolder")
      msisdnTemp.appendChild(msisdnTextSpan)
    }  else {
      var msisdnTextSpan = document.getElementById("msisdnTextSpan")
    }

    var productDetailAllow = false, tplDataAllow = false;

    if (_.isEmpty(this.$store.state.productdetail)) {
      if (this.xQuery['login_failed']) {
        productDetailAllow = true;
        this.states.mainView = false;
        this.states.isSSOFail = true;
        this.$router.replace({ query: _.omit(this.xQuery, ['login_failed'])})
      } else {
      that.$store.dispatch('refreshProductDetailRplnChange', this.$route.query).then(() => {
       if (that.$store.state.httpCodes.productdetail === 200) {
          that.productdetail = that.$store.state.productdetail
          that.msisdn = that.$store.state.productdetail.msisdn
          msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
       }        
       if (that.$store.state.httpCodes.productdetail === 403) {
          window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
       } else if (that.$store.state.httpCodes.productdetail === 400) {
          window.location.href = '/spotreba'
       } else if (that.$store.state.httpCodes.productdetail === 502) {
          that.states.showFail = true
          that.states.onServerError = true
       } else if (_.isEmpty(that.productdetail)) {
            that.states.showFail = true
       } else {
            productDetailAllow = true
            if (tplDataAllow) {
              that.states.viewAllow = true;
              this.setPecka();
            }
          }
      })
    }
    } else {
        that.productdetail = that.$store.state.productdetail
        that.msisdn = that.$store.state.productdetail.msisdn
        msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
        that.states.viewAllow = true
    }
    if (_.isEmpty(this.$store.state.tplData)) {
      that.$store.dispatch('refreshTplData').then(() => {
        that.tplData = that.$store.state.tplData
        tplDataAllow = true
        if (productDetailAllow) {
          that.states.viewAllow = true
          this.setPecka()
        }
      });
    } else {
        that.tplData = that.$store.state.tplData
        that.states.viewAllow = true
        this.setPecka()
    }
  },
  methods: {
    callAction: function(pAction) {
      window.history.pushState(null, '')
      window.onpopstate = function(event) {
      window.history.replaceState(null, '')
      that.states.mainView = true 
      that.baseView.addTYPage = false
      }

      this.baseView.addTYPage = true, this.states.mainView = false, this.baseView.TYText = this.tplData.credit.httpCallWait, this.baseView.TYInfoAlert = false
      var that = this
      axios.put('/pb/easy-api/packages', { name: "ActivateT", ext: ["1", "mweb"] }, { params: this.xQuery, headers: { 'x-check-rplncontrol': '1' }})
        .then(function (resp) {
            that.baseView.TYText = that.tplData.change.httpCallSuccess
            that.$store.dispatch('refreshProductDetailRplnChange', that.xQuery)

            if (that.isProd) {
              dataLayer.push({
                'event': 'purchase',
                'ecommerce': {
                  'purchase': {
                    'actionField': {
                      'id': new Date().getTime().toString(), 
                      'affiliation': 'm.telekom',
                      'revenue': '0'
                    },
                    'products': [{
                      'name': 'Predplatenka',  
                      'id': 'PR1853',
                      'price': '0',
                      'brand': 'm.telekom',
                      'category': 'Zmena_programu',
                      'quantity': 1 
                    }]
                  }
                }
              });              
            }
        })
        .catch(function(error){
          var resText = that.tplData.credit.httpCallFail
          if (error.response.status === 403) {
            window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
          } else {
            that.baseView.TYText = resText
            that.baseView.TYInfoAlert = true
          }
        })
        .finally(function() {
          that.baseView.TYBtn = true
        })
    },

    formatMsisdn: function(virgin) {
      return '0' + String(virgin).substring(3)
    },
    setPecka: function() {
      var that = this
      that.msg = that.tplData.change.title
      that.notAres = true
      if (((that.productdetail.product.productName).toLowerCase()).indexOf('t karta') !== -1) {
        that.states.denyOther = false
        that.states.isPredplatenka = true
      } else if (((that.productdetail.product.productName).toLowerCase()).indexOf('young') !== -1) {
        that.states.isYoung = true;
      }
      if ((((that.productdetail.product.productName).toLowerCase()).indexOf('ares') !== -1) ||  (((that.productdetail.product.productName).toLowerCase()).indexOf('juro') !== -1)) {
        that.notAres = false
      }
    },
    toProfile: function() {
      // window.location.href = "./profil" + window.location.search
      this.$router.replace({ path: '/profil', query: this.xQuery })
    }    
  },
  computed: {
    isProd: function() {
      if ((window.location.hostname == "m.telekom.sk") && (this.$store.state.activeAnalytic)) {
        return true
      } else {
        return false
      }
    },
    formatVMsisdn: function() {
        return ' 0' + String(this.productdetail.msisdn).substring(3);
    },
  }
}
</script>

<style scoped>
.disc_flex {
  display: flex;
  margin: 10px 0;
  padding: 1rem 0;
}

.check_flex {
  align-self: center;
  width: 40px; 
}

.cechcon {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

label {
  line-height: 1.2rem;
}

a.check_fail {
  pointer-events: none;
  color: #383838;;
  border: 2px solid  #a4a4a4;
  background-color: #ededed;
  font-weight: 400;
}

.cechcon input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: -14px;
  left: 0;
  height: 26px;
  width: 26px;
  border: 1px solid #666666;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.cechcon input:checked ~ .checkmark:after {
  display: block;
}

.cechcon .checkmark:after {
  left: 8px;
  top: 3px;
  width: 9px;
  height: 16px;
  border: solid #6bb324;
  border-width: 0 5px 5px 0;
  border-radius: 2px;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
